import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n';

export const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const language = (i18n.language || 'fr').toUpperCase();
  const toggle = () => changeLanguage(language === 'FR' ? 'en' : 'fr');

  return (
    <button
      onClick={toggle}
      className={`flex items-center text-sm font-semibold border border-slate-200 rounded-lg overflow-hidden ${className}`}
      data-testid="language-toggle"
      aria-label="Language"
    >
      <span
        className={`px-2.5 py-1.5 transition-colors ${language === 'FR' ? 'bg-blue-600 text-white' : 'text-slate-500'}`}
        data-testid="language-toggle-fr"
      >
        FR
      </span>
      <span
        className={`px-2.5 py-1.5 transition-colors ${language === 'EN' ? 'bg-blue-600 text-white' : 'text-slate-500'}`}
        data-testid="language-toggle-en"
      >
        EN
      </span>
    </button>
  );
};

export default LanguageToggle;
